// Finding your way into the Playbook.
//
// Seven cards, twenty thousand characters, and until now the only way in was
// tapping headers until the right one opened. Two things fix that, and both
// are here as pure functions so the component stays about rendering.
//
// Searching means searching the BODIES. The titles are six short lines; the
// thing Ward is actually looking for — what to do with the footage, what the
// athlete already agreed to, how the One Question is asked — is three
// thousand characters inside one of them. A search that only read titles
// would find nothing and teach him the box does not work.

const norm = (s) => (s || "").toLowerCase();

/** Everything in a card a search should be able to reach. `body_md` is on the
 *  list payload already, so this costs no extra request. */
export function cardHaystack(card) {
  return norm(`${card.title} ${card.summary} ${card.body_md}`);
}

/** The words in a query, in any order. "booking fee" matches "fee for a booking". */
export function queryTerms(q) {
  return norm(q).split(/\s+/).filter(Boolean);
}

export function matchesQuery(card, q) {
  const terms = queryTerms(q);
  if (!terms.length) return true;
  const hay = cardHaystack(card);
  return terms.every((t) => hay.includes(t));
}

/** Where the match was, so a card whose visible text does not contain the
 *  term does not look like a mistake. Null when there is no query. */
export function matchWhere(card, q) {
  const terms = queryTerms(q);
  if (!terms.length) return null;
  const head = norm(`${card.title} ${card.summary}`);
  return terms.every((t) => head.includes(t)) ? "head" : "body";
}

// "Both" is not a third category sitting beside Ward and Marco — it means the
// card asks something of each of them. Filtering to Ward has to keep it, or
// the filter hides work that is his.
export function matchesOwner(card, owner) {
  if (!owner) return true;
  if (owner === "both") return card.owner === "both";
  return card.owner === owner || card.owner === "both";
}

export function filterCards(cards, { q = "", owner = "" } = {}) {
  return cards.filter((c) => matchesOwner(c, owner) && matchesQuery(c, q));
}

// A rough minute count, not a promise. Characters over five is the usual
// stand-in for words, and 200wpm the usual reading speed; the markdown syntax
// inflates it a little and the tables slow you down a lot, so the two roughly
// cancel. The point is only to tell a 40-second card from a six-minute one
// before you commit to opening it on a phone.
export function readMinutes(card) {
  const words = (card.body_md || "").length / 5;
  return Math.max(1, Math.round(words / 200));
}
